// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"449":"aadc36a4","2866":"bcbb2702"}[chunkId] + ".chunk.css";
};